let resize_observer;
let subscribers = [];

let on_resize = function(el) {
	let scale = el.getBoundingClientRect().width / this.width;
	el.style.setProperty('--scale', 'scale(' + scale + ')');
}

class FlexCanvas {
	constructor(el, width, height) {
		this.el = document.createElement('div');
		this.el.classList.add('flex-canvas');
		this.el.style.setProperty('--width', width);
		this.el.style.setProperty('--height', height);
		this.el.style.setProperty('--scale', 1);
		this.width = width;
		this.height = height;
		this.el.setAttribute('data-width', width);
		this.el.setAttribute('data-height', height);

		el.parentNode.insertBefore(this.el, el);
		this.el.appendChild(el);

		if (!resize_observer) {
			resize_observer = new ResizeObserver(entries => {
				entries.forEach(entry => {
					if (subscribers.includes(entry.target)) {
						requestAnimationFrame(on_resize.bind(this, entry.target));	
					}
				})
			})
		}

		if (!subscribers.includes(this.el)) { 
			resize_observer.observe(this.el);
			subscribers.push(this.el);
		}
	}
}

export default (el, width, height) => {
	return new FlexCanvas(el, width, height);
}
